import {s_char_disciplines} from "../_signals/s_char";
import {DisciplinesSubscriber} from "./DataBehaves";

export default  function calcSchwelle(schwelle)  {
    let unempf:number[][] = [];
    let highest = 0;
    s_char_disciplines.value.forEach((d) => {
        let disz = DisciplinesSubscriber.value.find(dd => dd.name === d.name);
        if (disz) {
            let disz_unempf:number[] = []
            if (highest < d.circle) highest = d.circle;
            for (let i = 1; i <= d.circle; i++) {
                disz_unempf.push(parseInt(disz.TuF[1][schwelle]));
            }
            unempf.push(disz_unempf);
        }
    });

    let u = 0;
    for (let circleIndex = 0; circleIndex < highest; circleIndex++) {
        let max = 0;
        for (let diszIndex = 0; diszIndex < unempf.length; diszIndex++) {
            if (unempf[diszIndex] && unempf[diszIndex][circleIndex] !== undefined) {
                max = unempf[diszIndex][circleIndex] > max ? unempf[diszIndex][circleIndex] : max;
            }
            u += max;
        }
    }
    return u;
}
